import { render, staticRenderFns } from "./PFormRadioButton.vue?vue&type=template&id=3920280a&scoped=true"
import script from "./PFormRadioButton.vue?vue&type=script&lang=ts"
export * from "./PFormRadioButton.vue?vue&type=script&lang=ts"
import style0 from "./PFormRadioButton.vue?vue&type=style&index=0&id=3920280a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3920280a",
  null
  
)

export default component.exports